import { Box, Link, Typography } from '@mui/material';
import { useMemo } from 'react';
import { theme } from '../theme';

const Footer = () => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        textAlign: 'center',
        background: theme.palette.background.paper,
        width: '100%',
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        <Link
          href="/policies/privacy"
          color="inherit"
          sx={{
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Privacy
        </Link>
      </Typography>

      <Typography variant="body2" color="text.secondary">
        &copy; {currentYear} Street Ratings
      </Typography>
    </Box>
  );
};

export { Footer };
